const heightToTop = ele => {
  //ele为指定跳转到该位置的DOM节点
  let root = document.body;
  let top = 0;
  do {
    top += ele.offsetTop;
    ele = ele.offsetParent;
  } while (ele !== root);
  return top;
};

const scrollTo = (target, body, top = 14) => {
  const errorDom = document.querySelector(target);

  const u = navigator.userAgent;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
  let newTop = top;
  if (isIOS) {
    newTop = 110;
  }
  document.querySelector(body).scrollTop = heightToTop(errorDom) - newTop;
};
export default scrollTo;
